import Swiper from "swiper/bundle";

const swiper01 = new Swiper(".flow__leftRight", {
    slidesPerView: "auto",
    centeredSlides: true,
    spaceBetween: 15,
    speed: 28000,
    loop: true,
    autoplay: {
        delay: 0,
        disableOnInteraction: false,
    },
    simulateTouch: false,
    breakpoints: {
        1024: {
            speed: 20000,
        },
    },
});

const swiper02 = new Swiper(".flow__rightLeft", {
    slidesPerView: "auto",
    spaceBetween: 15,
    speed: 24000,
    loop: true,
    autoplay: {
        delay: 0,
        disableOnInteraction: false,
    },
    simulateTouch: false,
    breakpoints: {
        1024: {
            speed: 20000,
            autoplay: {
                reverseDirection: true,
                delay: 0,
                disableOnInteraction: false,
            },
        },
    },
});

const swiper03 = new Swiper(".footer__slider", {
    slidesPerView: "auto",
    centeredSlides: true,
    spaceBetween: 0,
    speed: 24000,
    loop: true,
    autoplay: {
        delay: 0,
        disableOnInteraction: false,
    },
    simulateTouch: false,
});